import React, { useCallback, useEffect, useState } from 'react';
import { Search, Title } from 'src/components';
import Table from 'src/components/table';
import { DashboardLayout } from 'src/containers';

import { AiOutlineEye } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import useFetch from 'src/hooks/useFetch';
import Service from 'src/setup/network';
import Card from 'src/components/card';
import { formatMoney } from 'src/utils';
import FieldDetail from 'src/components/FieldDetail';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { useDispatch } from 'react-redux';
import { fetchReceipt } from 'src/redux/action/receipt.action';
import Loader from 'src/components/loader';
import Button from 'src/components/button';
import DateFormat from 'src/components/DateFormat';
import { CurrencyAmount } from 'src/containers/currency';

interface IProps {}

const Receipt: React.FC<IProps> = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [query, setQuery] = React.useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [receiptData, setReceiptData] = useState([]);

  const fetchReceiptData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await Service.get('/payments/receipt');
      const data = await res?.data;
      setReceiptData(data);
      setIsLoading(false);
    } catch (err) {}
  }, []);

  useEffect(() => {
    fetchReceiptData();
  }, []);

  const searchReceiptData =
    receiptData &&
    receiptData?.filter((item: any) => {
      if (query === '') {
        return item;
      } else if (item?.name?.toLowerCase().includes(query.toLowerCase())) {
        return item;
      }
    });

  const tableColumn = [
    {
      Header: 'Date',
      accessor: 'createdAt',
      Cell: (row: any) => {
        return <>{<DateFormat text={row?.cell?.row?.original?.createdAt} />}</>;
      },
    },
    {
      Header: 'Receipt ID',
      accessor: '',
      Cell: (row: any) => <p>#{row?.cell?.row?.original?.referenceNumber}</p>,
    },
    {
      Header: 'Origin',
      accessor: 'origin',
      Cell: (row: any) => (
        <p>
          {row?.cell?.row?.original?.origin === 'pos_device'
            ? 'Pos Device'
            : row?.cell?.row?.orignal?.origin === 'customer_app'
            ? 'Customer App'
            : row?.cell?.row?.orignal?.origin === 'website'
            ? 'Website'
            : ''}
        </p>
      ),
    },
    {
      Header: 'Type',
      accessor: 'type',
      Cell: (row: any) => (
        <p
          className={`${
            row?.cell?.row?.original?.orderType === 'dine_in'
              ? 'border border-[#FEC02D] text-[#FEC02D]'
              : row?.cell?.row?.original?.orderType === 'delivery'
              ? 'border border-success text-success'
              : row?.cell?.row?.original?.orderType === 'takeaway'
              ? 'border border-warning text-warning'
              : row?.cell?.row?.original?.orderType === 'online_order'
              ? 'border border-primary text-primary'
              : ''
          } text-sm w-[135px] rounded capitalize py-2  text-center`}
        >
          {row?.cell?.row?.original?.orderType === 'dine_in'
            ? 'Dine In'
            : row?.cell?.row?.original?.orderType === 'delivery'
            ? 'Delivery'
            : row?.cell?.row?.original?.orderType === 'takeaway'
            ? 'Take Away'
            : row?.cell?.row?.original?.orderType === 'online_order'
            ? 'Online Order'
            : ''}
        </p>
      ),
    },
    {
      Header: 'Amount',
      accessor: 'total',
      Cell: (row: any) => <CurrencyAmount amount={row?.row?.values?.total}/>,
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: (row: any) => (
        <p
          className={`${
            row?.row?.values?.status === 'refunded'
              ? 'border border-warning text-warning'
              : row?.row?.values?.status === 'completed'
              ? 'border border-success text-success'
              : 'border border-primary text-primary'
          } text-sm w-[135px] rounded capitalize py-2  px-2 text-center`}
        >
          {row?.row?.values?.status}
        </p>
      ),
    },
    {
      Header: 'Action',
      accessor: 'action',
      Cell: (row: any) => (
        <div className="flex items-center space-x-3">
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() =>
              navigate(`/receipt-refund/${row?.cell?.row?.original?.id}`)
            }
          >
            <AiOutlineEye color="#4062FF" />
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="flex justify-between">
        <Search
          placeholder="search receipt"
          query={query}
          setQuery={setQuery}
        />
        <Button onClick={() => navigate('/view-refund')} text={'View Refund'} />
      </div>
      <div className="pb-10">
        <Table
          loading={isLoading}
          tableColumn={tableColumn}
          tableData={searchReceiptData}
        />
      </div>
    </>
  );
};

export default React.memo(Receipt);
